import { motion } from "framer-motion";
import { MessageCircle, PenTool, Truck } from "lucide-react";

const EASE = [0.22, 1, 0.36, 1];
const STEPS = [
    {
        n: "01",
        icon: MessageCircle,
        title: "Chat your idea",
        text: "Message us on WhatsApp or email with the name, photo or words you want printed.",
    },
    {
        n: "02",
        icon: PenTool,
        title: "We design & print",
        text: "We send a free mock-up, then print your order once you love it.",
    },
    {
        n: "03",
        icon: Truck,
        title: "Couriered to you",
        text: "Packed with care, delivered via PUDO, PAXI or The Courier Guy. Courier cost is not included.",
    },
];

export const Process = () => (
    <section id="how" className="mx-auto max-w-7xl px-5 pb-20 sm:px-8 md:pb-28" data-testid="process-section">
        <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.7, ease: EASE }}
        >
            <p className="text-xs font-bold uppercase tracking-[0.32em] text-sky-600">
                How to order
            </p>
            <h2 className="mt-4 max-w-xl font-display text-4xl font-medium leading-[1.05] tracking-tight text-sakura-900 sm:text-5xl">
                Three petals from chat
                <span className="italic text-sakura-600"> to doorstep</span>
            </h2>
        </motion.div>

        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3 md:gap-8">
            {STEPS.map((s, i) => (
                <motion.div
                    key={s.n}
                    data-testid={`process-step-${s.n}`}
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.2 }}
                    transition={{ duration: 0.7, delay: i * 0.12, ease: EASE }}
                    className="group relative overflow-hidden rounded-[1.75rem] border border-sky-300/70 bg-white/80 p-8 hover:bg-sky-50 transition-colors duration-300"
                >
                    <span className="pointer-events-none absolute -right-3 -top-6 font-display text-[7rem] font-semibold leading-none text-sky-300/70 group-hover:text-sky-400/80 transition-colors duration-300">
                        {s.n}
                    </span>
                    <span className="relative flex h-12 w-12 items-center justify-center rounded-full bg-sky-600 text-white shadow-[0_10px_24px_rgba(107,133,168,0.4)]">
                        <s.icon size={20} />
                    </span>
                    <h3 className="relative mt-6 font-display text-2xl font-semibold text-sakura-900">
                        {s.title}
                    </h3>
                    <p className="relative mt-2.5 text-[15px] leading-relaxed text-sakura-800/85">
                        {s.text}
                    </p>
                </motion.div>
            ))}
        </div>

        <motion.div
            data-testid="delivery-banner"
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.7, ease: EASE }}
            className="mt-8 flex flex-col items-start gap-5 rounded-[1.75rem] border border-sky-300/70 bg-sky-100 p-7 sm:flex-row sm:items-center sm:justify-between sm:p-8"
        >
            <div>
                <p className="font-display text-2xl font-semibold text-sakura-900">
                    Nationwide delivery across South Africa
                </p>
                <p className="mt-1 text-sm text-sakura-800/85">
                    Every area covered — courier cost is not included in
                    prices.
                </p>
            </div>
            <div className="flex flex-wrap gap-2.5">
                {["PUDO", "PAXI", "The Courier Guy"].map((c) => (
                    <span
                        key={c}
                        className="rounded-full border border-sky-600/30 bg-white/80 px-4 py-2 text-xs font-bold uppercase tracking-[0.14em] text-sky-700"
                    >
                        {c}
                    </span>
                ))}
            </div>
        </motion.div>
    </section>
);

export default Process;
